import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function PrivateRoute({ children, requiredPermission, requiredRoles, skipMfaCheck }) {
  const { currentUser, checkPermission, checkRole, mfaEnrolled, loading } = useAuth();

  // Nothing is known about the session yet; redirecting now would bounce a
  // signed-in user to /login or /mfa-setup.
  if (loading) {
    return null;
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Enforce MFA enrollment for all authenticated users unless skipMfaCheck is set
  if (!skipMfaCheck && !mfaEnrolled) {
    return <Navigate to="/mfa-setup" />;
  }

  if (requiredPermission && !checkPermission(requiredPermission)) {
    return <Navigate to="/" />;
  }
  if (requiredRoles && !requiredRoles.some(role => checkRole(role))) {
    return <Navigate to="/" />;
  }

  return children;
}

export default PrivateRoute;
